import styled from 'styled-components';

export const QuestionCounter = styled.div`
  font-size: 12px;
  color: #858585;
  font-weight: 500;
  margin-bottom: 16px;
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 6px;
  display: inline-block;
`;

export const FinalQuestionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #101010;
  margin: 0 0 24px 0;
  line-height: 1.6;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;
